<template>
  <div class="container choose-packages choose-packages-box">
    <div class="content text-center">
      <!-- <div class="packages-title-box">
        <div class="packages-title">{{ $t("enjoy") }}</div>
        <div class="title-underline"></div>
        <div class="days-box">
          <div class="days-icon">
            <img src="/static/img/newhome_img/ic_7-day.svg" alt />
          </div>
          <div class="days-text">7天退款保障</div>
        </div>
      </div> -->
      <div class="new-device-btn">
        <div class="numer-of-devies">
          <span>{{ $t("numberOfDevices") }}</span>
        </div>
        <div>
          <button
            v-for="item in devices"
            :key="item"
            @mouseover="chooseDevice(item)"
            :class="[
              { 'choose-device': item === currentDevice },
              'line-button',
            ]"
          >
            {{ item }}
          </button>
        </div>
      </div>
      <div
        :class="[
          'col-' + currentCol + '-box',
          'all-packages',
          'packages-list-box',
        ]"
      >
        <template v-for="(item, index) in packages">
          <packageItem
            :item="item"
            :key="'pkg' + index"
            :index="index"
            :currentPackage="currentPackage"
            @mouseover.native="currentPackage = item"
            @click-button="trakPackage(item)"
          ></packageItem>
        </template>
      </div>
      <h2 class="enjoy-title">{{ $t("unlimitedTraffic") }}</h2>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
// import $ from 'jquery'
import { addImpression } from "../../../assets/js/ecommerceAnalytics";
import locales from "./lang";
import Triangle from "../../../components/triangle/Triangle.vue";
import packageItem from "src/components/packageItem/packageItemNew.vue";
import GradientBtn from "../../../components/gradientBtn/GradientBtn.vue";
import { getKeyCount } from "../../../lib/arrayHandle";
import CountDown from "./countDownNew.vue";
import { mapState } from 'vuex';

function getSortUniqueDevices(packages) {
  let devices = packages.map(function (pkg) {
    return pkg.device_count;
  });
  devices.sort(function (a, b) {
    return a - b;
  });
  return _.sortedUniq(devices);
}

export default {
  name: "choosePackage",
  components: { Triangle, GradientBtn, CountDown, packageItem },
  props: ["allPackages"],
  data: function () {
    return {
      devices: "",
      currentDevice: "",
      currentPackage: "",
      packageCol: "",
      packageSort: 0,
      vipPackages: [],
      svipPackages: [],
      currentType: "",
      countDown: {
        total: "",
        days: "",
        hours: "",
        minutes: "",
        seconds: "",
      },
      bigstNum: 0,
    };
  },
  locales,
  computed: {
    currentSymbol() {
      return this.$store.state.currentSymbol;
    },
    mediaType() {
      return this.$store.state.mediaType;
    },
    currentCol() {
      return this.packageCol[this.currentDevice];
    },
    maxCol() {
      if (this.mediaType === "pc") {
        return 4;
      } else if (this.mediaType === "pad") {
        return 3;
      } else return 1;
    },
    packages() {
      if (this.currentType === "svip") {
        return this.svipPackages;
      } else {
        return this.vipPackages;
      }
    },
    ...mapState({
      hasToken: state => state.hasToken,
      user: state => state.user
    })
  },
  watch: {
    allPackages() {
      this.packagesClassification(this.allPackages);
      this.setCurrentType("vip");
      this.currentPackage = this.packages[0];
      // this.$emit('childFn', (100 - (this.currentPackage.price / this.currentPackage.list_price * 100)).toFixed(0) + '%');
    },
    currentDevice() {
      this.packageSort = 0;
    },
    packages() {
      this.addImpressionAnalytics(this.packages);
      this.devices = getSortUniqueDevices(this.packages);
      this.bigstNum = this.getBigstCount(this.packages);
      this.currentDevice = this.getDefaultDeviceCount();
      this.currentPackage = this.getCurrentPackage(this.currentDevice);
      this.packageCol = this.getPackageCol();
    },
    hasToken(val) {
      if (!val) {
        this.currentDevice = this.devices[0];
        this.currentPackage = this.getCurrentPackage(this.currentDevice);
      }
    }
  },
  mounted() {
    // this.getCountDown()
    // this.getCountDown('2021-01-07 02:18:00')
  },
  methods: {
    getDefaultDeviceCount() {
      if (!this.hasToken) {
        return this.devices[0];
      }

      if (this.devices.includes(this.user.max_device_count)) {
        return this.user.max_device_count;
      } else {
        for (let i of this.devices) {
          if (i > this.user.max_device_count) {
            return i;
          }
        }
      }
    },
    packagesClassification(allPackages) {
      this.svipPackages = []
      this.vipPackages = []
      for (let pkg of allPackages) {
        if (pkg.type === "svip") {
          if (pkg.is_recommended) {
            this.svipPackages.unshift(pkg);
          } else {
            this.svipPackages.push(pkg);
          }
        } else {
          if (pkg.is_recommended) {
            this.vipPackages.unshift(pkg);
          } else {
            this.vipPackages.push(pkg);
          }
        }
      }
    },
    setCurrentType(type) {
      this.currentType = type;
    },
    chooseDevice(deviceNum) {
      this.currentDevice = deviceNum;
      this.addImpressionAnalytics(this.packages);
      this.currentPackage = this.getCurrentPackage(deviceNum);
    },
    getCurrentPackage(deviceNum) {
      let defaultPackage = null;
      for (let pkg of this.packages) {
        if (!defaultPackage && pkg.device_count === deviceNum) {
          defaultPackage = pkg;
        }
        if (pkg.device_count === deviceNum && pkg.is_recommended) {
          return pkg;
        }
      }
      return defaultPackage || {};
    },
    getPackageCol() {
      let allDevices = this.packages
        .map(function (pkg) {
          return pkg.device_count;
        })
        .sort();
      let packageCol = {};
      this.devices.map(function (device) {
        let deviceShowCount = getKeyCount(device, allDevices);
        packageCol[device] = deviceShowCount;
      });
      return packageCol;
    },
    getBigstCount(pkg) {
      var num = 0;
      pkg.forEach((el) => {
        if (Number(100 - (el.price / el.list_price) * 100).toFixed(0) >= num) {
          num = (100 - (el.price / el.list_price) * 100).toFixed(0);
        }
      });
      this.$store.commit("getBigstCount", num);
      return num;
    },
    addImpressionAnalytics(allPackages) {
      for (let pkg of allPackages) {
        if (pkg.device_count === this.currentDevice && pkg.id > 0) {
          let deviceName = pkg.device_count > 1 ? "Devices" : "Device";
          let packageName =
            this.months(pkg) + "/" + pkg.device_count + " " + deviceName;
          let pkgTotalPrice = pkg.is_update
            ? (pkg.price + pkg.price_for_upgrade).toFixed(2)
            : pkg.price;
          addImpression({
            id: pkg.id,
            name: packageName,
            price: pkgTotalPrice,
            list: "PlexVPN",
            currency: this.currentSymbol,
            deviceCount: pkg.device_count,
          });
        }
      }
    },
    months(pkg) {
      if (pkg.frequency === "year") {
        return pkg.frequency_interval * 12;
      } else {
        return pkg.frequency_interval;
      }
    },
    trakPackage: function (pkg) {
      let deviceName = pkg.device_count > 0 ? "Devices" : "Device";
      let operation =
        pkg.device_count +
        " " +
        deviceName +
        "/" +
        pkg.frequency_interval +
        "" +
        pkg.frequency;
      this.$ga.event("Choose Packge", operation, "Home page choose Packge");
      this.$store.commit("setClickIndexPagePackageData", pkg);
      
      localStorage.setItem('currentDevice', this.currentDevice)
      // 如果是登录直接走购买逻辑
      if (this.$store.state.user.id) {
        this.$router.push("/dashboard");
        // this.$store.commit('setCurrentPackage', pkg)
        // $('#pay-order').modal('show')
      } else {
        this.$router.push("/login");
      }
    },
    getPackageName(name) {
      return name.split("（")[0] || "";
    },
    countDownFunc(endTime) {
      const nowTime = new Date();
      const endTime1 = new Date(endTime);
      let times = (endTime1 - nowTime) / 1000;

      let days = 0;
      let hours = 0;
      let minutes = 0;
      let seconds = 0;
      days = Math.floor(times / 60 / 60 / 24) + "";
      hours = Math.floor((times / 60 / 60) % 24) + "";
      minutes = Math.floor((times / 60) % 60) + "";
      seconds = Math.floor(times % 60);

      if (days <= 9) {
        days = "0" + days;
      }
      if (hours <= 9) {
        hours = "0" + hours;
      }
      if (minutes <= 9) {
        minutes = "0" + minutes;
      }
      if (seconds <= 9) {
        seconds = "0" + seconds;
      }

      this.countDown = {
        total: times,
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      };
    },
    getCountDown(endTime) {
      let timer = setInterval(() => {
        this.countDownFunc(endTime);
        if (this.countDown.total <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
  },
  filters: {
    getDiscount(pkg) {
      if (pkg.list_price) {
        return (100 - (pkg.price / pkg.list_price) * 100).toFixed(0) + "%";
      }
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
// @import "./choosePackage";
.container {
  background: #fff;
}
.choose-packages-box {
  padding: 0;
  position: relative;
  padding-top: 64px;
  .content {
    padding: 0;
    max-width: 11.8rem;
    margin: 0 auto;
    position: relative;
    z-index: 2;
    @media screen and (max-width: 1228px) {
      padding: 0 24px;
    }
  }

  .all-packages {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    flex-wrap: wrap;
  }

  .packages-title-box {
    text-align: center;
    display: none;
    .packages-title {
      font-size: 40px;
      color: #111111;
      letter-spacing: 2px;
      line-height: 40px;
      font-weight: 600;
    }
    .title-underline {
      width: 60px;
      height: 4px;
      background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
      margin: 0 auto;
      margin-top: 24px;
    }
    .days-box {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      .days-icon {
        width: 16px;
        height: 16px;
        // line-height: 20px;
        margin-right: 8px;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          vertical-align: baseline;
        }
      }
      .days-text {
        font-size: 16px;
        color: #666666;
        letter-spacing: 0;
        // line-height: 20px;
        font-weight: 400;
      }
    }
  }
  .new-device-btn {
    margin-bottom: 94px;
    display: flex;
    justify-content: center;
    align-items: center;
    .numer-of-devies {
      margin-right: 16px;
    }
    span {
      font-size: 20px;
      color: #333333;
      letter-spacing: 0;
      text-align: right;
      line-height: 20px;
      font-weight: 600;
    }
    .line-button {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background: #ffffff;
      border: 1px solid rgba(224, 215, 227, 1);
      font-size: 18px;
      color: #999999;
      letter-spacing: 0.64px;
      text-align: center;
      padding-right: 6px;
      font-weight: 400;
      margin-right: 16px;
    }
    .choose-device {
      color: #ffffff;
      background-image: linear-gradient(180deg, #416cf8 3%, #ec55ff 100%);
    }
  }
  .enjoy-title {
    font-size: 24px;
    color: #111111;
    letter-spacing: 1px;
    line-height: 32px;
    font-weight: 400;
    margin-top: 53px;
  }
}
@media (max-width: 1024px) {
  .choose-packages {
    padding-top: 40px;
    .packages-title-box {
      .packages-title {
        font-size: 24px;
        letter-spacing: 0;
        line-height: 32px;
      }
      .title-underline {
        margin-top: 16px;
        width: 40px;
      }
      .days-box {
        .days-icon {
          width: 14px;
        }
        .days-text {
          font-size: 14px;
        }
      }
    }
    .new-device-btn {
      flex-wrap: wrap;
      margin: 0 auto 9px auto;
      .numer-of-devies {
        margin-bottom: 16px;
      }
      .line-button {
        width: 28px;
        height: 28px;
        font-size: 16px;
        letter-spacing: 0.57px;
        line-height: 20px;
        padding: 0;
        margin-right: 15px;
        margin-bottom: 15px;
        &:first-child {
          margin-left: 10px;
        }
      }
    }
  }
  .choose-packages-box {
    .enjoy-title {
      font-size: 18px;
      color: #333333;
      margin: auto;
      text-align: center;
      letter-spacing: 0.86px;
      line-height: 24px;
      font-weight: 400;
      margin-top: 10px;
      padding: 0 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ChoosePackageNew.vue?f3ad5926